import type { PlatformWebRouteContribution } from '@crest/platform-web/module-runtime';

export interface CrestAccountAccessSummary {
  readonly companyDisplayName: string;
  readonly tasksAvailable: boolean;
}

export function buildCrestAccountAccessSummary(
  companyDisplayName: string,
  availableRoutes: readonly Pick<PlatformWebRouteContribution, 'id'>[],
): CrestAccountAccessSummary {
  return {
    companyDisplayName,
    tasksAvailable: availableRoutes.some(({ id }) => id === 'tasks.web.work-queue'),
  };
}

/** Read-only presentation of the current shell's already resolved route access. */
export function CrestAccountAccessPanel(props: CrestAccountAccessSummary) {
  return (
    <section className="crest-card" aria-labelledby="crest-account-access-title">
      <h2 id="crest-account-access-title">Your workspace access</h2>
      <p>{props.companyDisplayName}</p>
      <p role="status">
        {props.tasksAvailable
          ? 'Tasks is available in this session.'
          : 'Tasks is not available in this session.'}
      </p>
      <p className="crest-muted">
        {props.tasksAvailable
          ? 'Your task actions still depend on your assigned role and access to each project.'
          : 'If you need Tasks for your work, ask your company administrator to review your account access.'}
      </p>
      <p className="crest-muted">Changing your password does not change your workspace access.</p>
    </section>
  );
}
